/* eslint-disable no-shadow */
export interface PrintScanBarcodesState {
  barcodesPrinting: boolean;
  barcodesList: Barcode[];
  barcodeType: BarcodeGenerationType;
  storeBarcodeList: StoreBarcodeList[];
}

export interface Barcode {
  code: string;
  createdAt: number;
  generationType: BarcodeGenerationType;
  id: number;
  order: {
    id: number;
  };
  orderId: number;
  position: number;
  status: BarcodeStatus;
}

export enum BarcodeGenerationType {
  prePrinted = 'prePrinted',
  system = 'system',
}

export enum BarcodeStatus {
  generated = 'generated',
  scanned = 'scanned',
}

export interface StoreBarcodeList {
  index: number;
  storeName: string;
  storeLogo: string;
  barcodeCount: number;
}
